export enum LeaveRequestCategory {
    SickLeave = "Sick Leave",
    PersonalLeave = "Personal Leave",
    AnnualLeave = "Annual Leave",
    NationalHoliday = 'National Holiday',
    ShiftChange = "Shift Change",
    Work = "Work"
}